// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"698":"3938cc82","816":"b0a7fe24","898":"bdd553cc"}[chunkId] + ".chunk.js";
};